import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitTypeServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitTypeServices";

const AddNewStudyKitTypeMetadata = ({ getEIWRSKitTypeMetadataData }) => {
  let { studyId } = useParams();
  const [kitType, setKitType] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewEIWRSKitTypeMetadata = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.type = kitType;
    let data = await eiwrsKitTypeServices.addNewEIWRSKitTypeMetadata(
      userData
    );
    if (data?.statusCode === 200) {
      setKitType("");
      getEIWRSKitTypeMetadataData()
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    setKitType("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Kit Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setKitType(e.target.value)}
          value={kitType}
          className="br3"
          placeholder="Enter Kit Type"
          type="text"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!kitType || buttonLoader}
          onClick={addNewEIWRSKitTypeMetadata}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Kit Type"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyKitTypeMetadata;
